exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subImg[data-v-a67d8ae4]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.subImg img[data-v-a67d8ae4]{width:100px;height:100px;-o-object-fit:cover;object-fit:cover;margin-right:10px;margin-bottom:10px;cursor:pointer}.img-preview-dialog .el-dialog__body[data-v-a67d8ae4]{padding:10px 20px 20px 20px}", ""]);

// exports
